export const tipoFornecedor = [
  'Serviços',
  'Materiais',
];

export const tamanhoEmpresa = [
  'P',
  'M',
  'G',
];

export const tipoContrato = [
  'Simplificado',
  'Completo',
];

export const tipoAnalise = [
  'Com análise qualitativa',
  'Sem análise qualitativa',
];

export const dfAuditada = [
  'Sim',
  'Não',
];

// SEMPRE TEM QUE ESTAR SINCRONIZADO COM O SERVICES/PARTNER/VOLTZ NO PARSE-SERVER
export const variables = {
  'Serviços:P:Simplificado:Com análise qualitativa': [
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
    { label: 'Operação', value: 'operacao' },
  ],
  'Serviços:P:Simplificado:Sem análise qualitativa': [
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
    { label: 'Operação', value: 'operacao' },
  ],
  'Serviços:P:Completo:Com análise qualitativa': [
    { label: 'Controladoria', value: 'controladoria' },
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
    { label: 'Operação', value: 'operacao' },
  ],
  'Serviços:P:Completo:Sem análise qualitativa': [
    { label: 'Controladoria', value: 'controladoria' },
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
    { label: 'Operação', value: 'operacao' },
  ],
  'Serviços:M:Simplificado:Com análise qualitativa': [
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
    { label: 'Operação', value: 'operacao' },
  ],
  'Serviços:M:Simplificado:Sem análise qualitativa': [
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
    { label: 'Operação', value: 'operacao' },
  ],
  'Serviços:M:Completo:Com análise qualitativa': [
    { label: 'Controladoria', value: 'controladoria' },
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
    { label: 'Operação', value: 'operacao' },
  ],
  'Serviços:M:Completo:Sem análise qualitativa': [
    { label: 'Controladoria', value: 'controladoria' },
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
    { label: 'Operação', value: 'operacao' },
  ],
  'Serviços:G:Simplificado:Com análise qualitativa': [
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
    { label: 'Operação', value: 'operacao' },
    { label: 'Ind. Finan.', value: 'indicadoresFinanceiros' },
  ],
  'Serviços:G:Simplificado:Sem análise qualitativa': [
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
    { label: 'Operação', value: 'operacao' },
    { label: 'Ind. Finan.', value: 'indicadoresFinanceiros' },
  ],
  'Serviços:G:Completo:Com análise qualitativa': [
    { label: 'Controladoria', value: 'controladoria' },
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
    { label: 'Operação', value: 'operacao' },
    { label: 'Ind. Finan.', value: 'indicadoresFinanceiros' },
  ],
  'Serviços:G:Completo:Sem análise qualitativa': [
    { label: 'Controladoria', value: 'controladoria' },
    { label: 'Jurídico', value: 'juridico' },
    { label: 'Gestor', value: 'gestor' },
    { label: 'Operação', value: 'operacao' },
    { label: 'Ind. Finan.', value: 'indicadoresFinanceiros' },
  ],
  'Materiais:P::Com análise qualitativa': [
    { label: 'BI materiais', value: 'biMateriais' },
    { label: 'Operação', value: 'operacao' },
    { label: 'OTIF', value: 'otif' },
  ],
  'Materiais:P::Sem análise qualitativa': [
    { label: 'BI materiais', value: 'biMateriais' },
    { label: 'Operação', value: 'operacao' },
    { label: 'OTIF', value: 'otif' },
  ],
  'Materiais:M::Com análise qualitativa': [
    { label: 'BI materiais', value: 'biMateriais' },
    { label: 'Operação', value: 'operacao' },
    { label: 'OTIF', value: 'otif' },
  ],
  'Materiais:M::Sem análise qualitativa': [
    { label: 'BI materiais', value: 'biMateriais' },
    { label: 'Operação', value: 'operacao' },
    { label: 'OTIF', value: 'otif' },
  ],
  'Materiais:G::Com análise qualitativa': [
    { label: 'BI materiais', value: 'biMateriais' },
    { label: 'Operação', value: 'operacao' },
    { label: 'OTIF', value: 'otif' },
    { label: 'Ind. Finan.', value: 'indicadoresFinanceiros' },
  ],
  'Materiais:G::Sem análise qualitativa': [
    { label: 'BI materiais', value: 'biMateriais' },
    { label: 'Operação', value: 'operacao' },
    { label: 'OTIF', value: 'otif' },
    { label: 'Ind. Finan.', value: 'indicadoresFinanceiros' },
  ],
};

export const variableOptions = {
  Serviços: {
    controladoria: {
      100: 'Conforme (fornecedor não possui bloqueio)',
      30: {
        tamanhoEmpresa: {
          P: 'Parcialmente conforme (fornecedor possui bloqueio por renovação de seguros)',
          M: 'Parcialmente conforme (fornecedor possui bloqueio por renovação de seguros)',
          G: 'Parcialmente conforme (fornecedor possui bloqueio por renovação de seguros ex-garantia)',
        },
      },
      0: {
        tamanhoEmpresa: {
          P: 'Não conforme (fornecedor possui bloqueio por não envio de comprovantes)',
          M: 'Não conforme (fornecedor possui bloqueio por não envio de comprovantes)',
          G: 'Não conforme (fornecedor possui bloqueio por não envio de comprovantes OU pendência seguro garantia)',
        },
      },
    },
    juridico: {
      100: 'Conforme (fornecedor não possui nenhum processo)',
      30: {
        tamanhoEmpresa: {
          P: 'Parcialmente conforme (fornecedor possui processos com perda provável até 50% do faturamento médio mensal)',
          M: 'Parcialmente conforme (fornecedor possui processos com perda provável até 50% do faturamento médio mensal)',
          G: 'Parcialmente conforme (fornecedor possui processos com perda provável até 100% do faturamento médio mensal)',
        },
      },
      0: {
        tamanhoEmpresa: {
          P: 'Não conforme (fornecedor possui processos com perda provável acima de 50% do faturamento médio mensal)',
          M: 'Não conforme (fornecedor possui processos com perda provável acima de 50% do faturamento médio mensal)',
          G: 'Não conforme (fornecedor possui processos com perda provável acima de 100% do faturamento médio mensal)',
        },
      },
    },
    gestor: {
      100: 'Conforme (fornecedor prestando serviço normalmente)',
      30: 'Parcialmente conforme (fornecedor está prestando serviço mas houve queda/perspectiva redução ou alto turnover)',
      0: 'Não conforme (fornecedor não está pagando fornecedores regionais / muitas ocorrências / risco de rescisão)',
    },
    operacao: {
      100: {
        tamanhoEmpresa: {
          P: 'Conforme (para investimentos ou capital de giro de até 50% do faturamento mensal Energisa)',
          M: 'Conforme (para investimentos ou capital de giro de até 50% do faturamento mensal Energisa)',
          G: 'Conforme (para investimentos ou capital de giro de até 1x do faturamento mensal Energisa)',
        },
      },
      30: {
        tamanhoEmpresa: {
          P: 'Parcialmente conforme (para capital de giro até 100% do faturamento mensal Energisa)',
          M: 'Parcialmente conforme (para capital de giro até 100% do faturamento mensal Energisa)',
          G: 'Parcialmente conforme (para capital de giro até 2,5x do faturamento mensal Energisa)',
        },
      },
      0: {
        tamanhoEmpresa: {
          P: 'Não conforme (capital de giro acima de 100% do faturamento mensal)',
          M: 'Não conforme (capital de giro acima de 100% do faturamento mensal)',
          G: 'Não conforme (capital de giro acima de 2,5x do faturamento mensal Energisa)',
        },
      },
    },
    externaScr: {
      100: {
        tamanhoEmpresa: {
          P: 'Conforme (com limite e sem créditos vencidos)',
          M: 'Conforme (Dívida até 1,5x faturamento mensal médio (total) E sem créditos vencidos)',
          G: 'Conforme (Dívida até 2,5x faturamento mensal médio (total) E sem créditos vencidos)',
        },
      },
      30: {
        tamanhoEmpresa: {
          P: 'Parcialmente conforme (com limite mas crédito vencido OU sem limite mas sem crédito vencido)',
          M: 'Parcialmente conforme (Dívida até 2,5x faturamento mensal médio (total) E sem créditos vencidos)',
          G: 'Parcialmente conforme (Dívida até 5x faturamento mensal médio (total) E sem créditos vencidos)',
        },
      },
      0: {
        tamanhoEmpresa: {
          P: 'Não conforme (sem limite e com crédito vencido)',
          M: 'Não conforme (Dívida > 2,5x faturamento mensal médio (total) OU com créditos vencidos)',
          G: 'Não conforme (Dívida > 5x faturamento mensal médio (total) OU com créditos vencidos)',
        },
      },
    },
    analiseRisco: {
      100: 'Conforme (Baixo risco)',
      30: 'Parcialmente conforme (Médio risco)',
      0: 'Não conforme (Alto risco)',
    },
    indicadoresFinanceiros: {
      100: 'Conforme (LC >= 1,5x E FCO > 0 E LL > 0)',
      30: 'Parcialmente conforme (LC >= 1,0x E FCO > 0 OU LL < 0)',
      0: 'Não conforme (LC < 1,0x E FCO < 0 E LL < 0)',
    },
    serasa: {
      100: 'Conforme (Até 20% faturamento mensal em protestos)',
      30: 'Parcialmente conforme (Até 30% faturamento mensal em protestos)',
      0: 'Não conforme (Acima 30% faturamento mensal em protestos)',
    },
  },
  Materiais: {
    biMateriais: {
      100: 'Conforme (consumo regular ou acelerado)',
      30: 'Parcialmente conforme (consumo baixo mas com mais de 50% de prazo)',
      0: 'Não conforme (consumo baixo e menos de 50% de prazo restante)',
    },
    operacao: {
      100: 'Conforme (para investimentos ou capital de giro de até 50% do faturamento mensal Energisa)',
      30: 'Parcialmente conforme (para capital de giro até 100% do faturamento mensal Energisa)',
      0: 'Não conforme (capital de giro acima de 100% do faturamento mensal)',
    },
    externaScr: {
      100: {
        tamanhoEmpresa: {
          P: 'Conforme (com limite e sem créditos vencidos)',
          M: 'Conforme (Dívida até 1,5x faturamento mensal médio (total) E sem créditos vencidos)',
          G: 'Conforme (Dívida até 2,5x faturamento mensal médio (total) E sem créditos vencidos)',
        },
      },
      30: {
        tamanhoEmpresa: {
          P: 'Parcialmente conforme (com limite mas crédito vencido OU sem limite mas sem crédito vencido)',
          M: 'Parcialmente conforme (Dívida até 2,5x faturamento mensal médio (total) E sem créditos vencidos)',
          G: 'Parcialmente conforme (Dívida até 5x faturamento mensal médio (total) E sem créditos vencidos)',
        },
      },
      0: {
        tamanhoEmpresa: {
          P: 'Não conforme (sem limite e com crédito vencido)',
          M: 'Não conforme (Dívida > 2,5x faturamento mensal médio (total) OU com créditos vencidos)',
          G: 'Não conforme (Dívida > 5x faturamento mensal médio (total) OU com créditos vencidos)',
        },
      },
    },
    otif: {
      100: 'Conforme (Acima de 70%)',
      30: 'Parcialmente conforme (50,01% a 70%)',
      0: 'Não conforme (0% a 50%)',
    },
    analiseRisco: {
      100: 'Conforme (Baixo risco)',
      30: 'Parcialmente conforme (Médio risco)',
      0: 'Não conforme (Alto risco)',
    },
    indicadoresFinanceiros: {
      100: 'Conforme (LC >= 1,5x E FCO > 0 E LL > 0)',
      30: 'Parcialmente conforme (LC >= 1,0x E FCO > 0 OU LL < 0)',
      0: 'Não conforme (LC < 1,0x E FCO < 0 E LL < 0)',
    },
    serasa: {
      100: 'Conforme (Até 20% faturamento mensal em protestos)',
      30: 'Parcialmente conforme (Até 30% faturamento mensal em protestos)',
      0: 'Não conforme (Acima 30% faturamento mensal em protestos)',
    },
  },
};
